import React, { useContext, useEffect, useRef, useState } from 'react'
import liff from '@line/liff';
import Context from '../../app_context/Context';
import { useNavigate } from 'react-router-dom';
import { get_point_balance_store_by_mobile } from '../../page_action/customer_list';
import Datalist from './DataList';

export default function Page({ }) {
    const { userData, setUserData, menuShow, setMenuShow, set_site_title } = useContext(Context);
    const navigation = useNavigate();
    const [isExternalBrowser, setIsExternalBrowser] = useState(false);

    const [data, setData] = useState(null);

    useEffect(() => {
        set_site_title("MK-Rewards | หน้าแรก")
    }, [])

    useEffect(() => {
        if (userData) {
            let form = {
                "MOBILE": userData.data_main.MOBILE
            }
            get_point_balance_store_by_mobile(form, setData)
        }
    }, [userData])

    useEffect(() => {
        if (data) {
            // console.log(JSON.stringify(data, null, 2))
        }
    }, [data])

    useEffect(() => {
        // ตรวจสอบว่าเป็น external browser หรือไม่
        const checkBrowser = async () => {
            try {
                const os = await liff.getOS();
                // ถ้าเป็น web จะแสดงปุ่ม logout
                setIsExternalBrowser(os === 'web');
            } catch (error) {
                console.error('Error checking browser:', error);
            }
        };

        checkBrowser();
    }, []);


    return (
        <div className="min-h-screen w-full max-w-200 flex items-center justify-center bg-gray-50 px-3 bg-fixed"
            style={{
                backgroundImage: 'url("https://www.mkmedical.online:444/image_wheel_game/chinese-newyear.png?123")',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
            }}
        >

            <div className="w-full max-w-7xl">
                <div className='mx-auto'>
                    <Datalist data={data} />
                </div>
                {data && data.length === 0 ?
                    <div className="bg-white bg-opacity-90 rounded-lg shadow-md p-8 text-center">
                        <div className="flex flex-col items-center gap-4">
                            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
                                <svg
                                    className="w-8 h-8 text-orange-500"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                            </div>
                            <div className="space-y-2">
                                <h3 className="text-lg font-semibold text-gray-900">
                                    {userData.data_main.MOBILE}
                                </h3>
                                <h3 className="text-lg font-semibold text-gray-900">
                                    ไม่พบร้านค้าในระบบ
                                </h3>
                                <p className="text-gray-600">
                                    กรุณาติดต่อเจ้าหน้าที่
                                </p>
                            </div>
                        </div>
                    </div>
                    : null}
                {/* ส่วนปุ่มออกจากระบบ */}
                {isExternalBrowser && (
                    <div className='mt-4 mb-4'>
                        <div className="flex flex-col items-center space-y-3">
                            <button
                                type="button"
                                className="group relative w-full sm:w-64 flex items-center justify-center gap-2 
                                rounded-lg bg-gradient-to-r from-orange-500 to-orange-600 
                                px-4 py-3 text-sm font-medium text-white 
                                shadow-lg shadow-orange-500/30
                                hover:from-orange-600 hover:to-orange-700 
                                active:shadow-none
                                transition-all duration-200 ease-in-out"
                                onClick={() => {
                                    liff.logout()
                                    window.location.href = '/mk-rewards/authentication'
                                }}
                            >
                                <span className="absolute left-4 opacity-70 group-hover:scale-110 transition-transform">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                        />
                                    </svg>
                                </span>
                                <span className="ml-4">ออกจากระบบ</span>
                            </button>
                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}
